(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5838],{

/***/ 27532:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ ButtonHierarchy; },
/* harmony export */   "z": function() { return /* binding */ Button; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(14251);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52875);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(44747);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _button_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11069);
/* harmony import */ var _button_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_button_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _types_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16693);








var Icon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(8075), __webpack_require__.e(9878), __webpack_require__.e(6244)]).then(__webpack_require__.bind(__webpack_require__, 56244));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(56244)
            ];
        }
    }
});
var ButtonHierarchy;
(function(ButtonHierarchy) {
    ButtonHierarchy["Bezeled"] = "bezeled";
    ButtonHierarchy["BezeledGray"] = "bezeled-gray";
    ButtonHierarchy["Borderless"] = "borderless";
    ButtonHierarchy["BorderlessGray"] = "borderless-gray";
    ButtonHierarchy["ChipChoice"] = "chip-choice";
    ButtonHierarchy["ChipFilter"] = "chip-filter";
    ButtonHierarchy["Filled"] = "filled";
    ButtonHierarchy["Outline"] = "outline";
    ButtonHierarchy["Success"] = "success";
    ButtonHierarchy["TabChoice"] = "tab-choice";
    ButtonHierarchy["Text"] = "text";
    ButtonHierarchy["Black"] = "black";
})(ButtonHierarchy || (ButtonHierarchy = {}));
var Button = function(_param) {
    var hierarchy = _param.hierarchy, _disabled = _param.disabled, disabled = _disabled === void 0 ? false : _disabled, label = _param.label, size = _param.size, _icon = _param.icon, icon = _icon === void 0 ? "" : _icon, _iconPosition = _param.iconPosition, iconPosition = _iconPosition === void 0 ? "left" : _iconPosition, _leadingIcon = _param.leadingIcon, leadingIcon = _leadingIcon === void 0 ? "" : _leadingIcon, _trailingIcon = _param.trailingIcon, trailingIcon = _trailingIcon === void 0 ? "" : _trailingIcon, _isSelected = _param.isSelected, isSelected = _isSelected === void 0 ? false : _isSelected, _hasBackground = _param.hasBackground, hasBackground = _hasBackground === void 0 ? true : _hasBackground, _hasPadding = _param.hasPadding, hasPadding = _hasPadding === void 0 ? true : _hasPadding, _hasTransition = _param.hasTransition, hasTransition = _hasTransition === void 0 ? true : _hasTransition, _hasUnderline = _param.hasUnderline, hasUnderline = _hasUnderline === void 0 ? false : _hasUnderline, _theme = _param.theme, theme = _theme === void 0 ? _types_system__WEBPACK_IMPORTED_MODULE_3__/* .Theme.light */ .Q2.light : _theme, ariaLabel = _param.ariaLabel, _isSquare = _param.isSquare, isSquare = _isSquare === void 0 ? false : _isSquare, _isLoading = _param.isLoading, isLoading = _isLoading === void 0 ? false : _isLoading, _hasIcon = _param.hasIcon, hasIcon = _hasIcon === void 0 ? false : _hasIcon, _className = _param.className, className = _className === void 0 ? "" : _className, _type = _param.type, type = _type === void 0 ? "button" : _type, children = _param.children, _loader = _param.loader, loader = _loader === void 0 ? "default" : _loader, _retainWidthOnLoadingState = _param.retainWidthOnLoadingState, retainWidthOnLoadingState = _retainWidthOnLoadingState === void 0 ? false : _retainWidthOnLoadingState, restProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "hierarchy",
        "disabled",
        "label",
        "size",
        "icon",
        "iconPosition",
        "leadingIcon",
        "trailingIcon",
        "isSelected",
        "hasBackground",
        "hasPadding",
        "hasTransition",
        "hasUnderline",
        "theme",
        "ariaLabel",
        "isSquare",
        "isLoading",
        "hasIcon",
        "className",
        "type",
        "children",
        "loader",
        "retainWidthOnLoadingState"
    ]);
    var commonProps = {
        className: "".concat((_button_module_scss__WEBPACK_IMPORTED_MODULE_5___default().main), " ").concat(className),
        "data-is-square": icon && !label || isSquare.toString(),
        "data-hierarchy": hierarchy,
        "data-selected": isSelected,
        "data-size": size,
        "data-has-transition": isLoading ? false : hasTransition,
        "data-has-icon": hasIcon || !!icon || !!leadingIcon || !!trailingIcon,
        "data-icon-position": iconPosition,
        "data-has-background": hasBackground,
        "data-has-padding": hasPadding,
        "data-theme": theme,
        "aria-label": ariaLabel ? ariaLabel : icon ? icon : label,
        "data-has-underline": hasUnderline,
        "data-is-loading": isLoading,
        "data-retains-width-on-load": retainWidthOnLoadingState,
        disabled: disabled
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, restProps, commonProps), {
        onClick: function(e) {
            if (isLoading) {
                return;
            }
            if (restProps.onClick) {
                restProps.onClick(e);
            }
        },
        type: type,
        children: [
            leadingIcon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Icon, {
                name: leadingIcon,
                size: size === _types_system__WEBPACK_IMPORTED_MODULE_3__/* .Size.Large */ .$u.Large ? _types_system__WEBPACK_IMPORTED_MODULE_3__/* .Size.Large */ .$u.Large : _types_system__WEBPACK_IMPORTED_MODULE_3__/* .Size.Medium */ .$u.Medium
            }),
            iconPosition === "right" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: (_button_module_scss__WEBPACK_IMPORTED_MODULE_5___default().label),
                children: label
            }),
            icon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Icon, {
                name: icon,
                size: size === _types_system__WEBPACK_IMPORTED_MODULE_3__/* .Size.Large */ .$u.Large ? _types_system__WEBPACK_IMPORTED_MODULE_3__/* .Size.Large */ .$u.Large : _types_system__WEBPACK_IMPORTED_MODULE_3__/* .Size.Medium */ .$u.Medium
            }),
            iconPosition === "left" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: (_button_module_scss__WEBPACK_IMPORTED_MODULE_5___default().label),
                children: label
            }),
            isLoading && (loader === "dots" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_button_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["loader-container"]),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: (_button_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["loader-dots"])
                })
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Icon, {
                customClass: (_button_module_scss__WEBPACK_IMPORTED_MODULE_5___default().loader),
                name: "Loader2",
                size: size === _types_system__WEBPACK_IMPORTED_MODULE_3__/* .Size.Large */ .$u.Large ? _types_system__WEBPACK_IMPORTED_MODULE_3__/* .Size.Large */ .$u.Large : _types_system__WEBPACK_IMPORTED_MODULE_3__/* .Size.Medium */ .$u.Medium
            })),
            trailingIcon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Icon, {
                name: trailingIcon,
                size: size === _types_system__WEBPACK_IMPORTED_MODULE_3__/* .Size.Large */ .$u.Large ? _types_system__WEBPACK_IMPORTED_MODULE_3__/* .Size.Large */ .$u.Large : _types_system__WEBPACK_IMPORTED_MODULE_3__/* .Size.Medium */ .$u.Medium
            }),
            children
        ]
    }));
};


/***/ }),

/***/ 96732:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* reexport safe */ _Button__WEBPACK_IMPORTED_MODULE_0__.B; },
/* harmony export */   "z": function() { return /* reexport safe */ _Button__WEBPACK_IMPORTED_MODULE_0__.z; }
/* harmony export */ });
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27532);



/***/ }),

/***/ 45838:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ DebugWidget; }
});

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(80969);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./lib/hooks/useExperiment.ts
var useExperiment = __webpack_require__(46389);
// EXTERNAL MODULE: ./types/system.ts
var system = __webpack_require__(16693);
// EXTERNAL MODULE: ./components/styleguide/Button/index.ts
var Button = __webpack_require__(96732);
// EXTERNAL MODULE: ./components/styleguide/Link/index.ts + 1 modules
var Link = __webpack_require__(63383);
// EXTERNAL MODULE: ./components/styleguide/DebugWidget/debug-widget.module.scss
var debug_widget_module = __webpack_require__(29183);
var debug_widget_module_default = /*#__PURE__*/__webpack_require__.n(debug_widget_module);
// EXTERNAL MODULE: ./lib/utilities/system.js + 1 modules
var utilities_system = __webpack_require__(70591);
;// CONCATENATED MODULE: ./components/styleguide/DebugWidget/DebugWidget.tsx









var DebugWidget = function() {
    var ref = (0,_sliced_to_array/* default */.Z)((0,useExperiment/* useExperiment */.a)(), 1), experimentGroup = ref[0];
    var ref1 = (0,react.useState)(false), showDebug = ref1[0], setShowDebug = ref1[1];
    (0,react.useEffect)(function() {
        setShowDebug(!(0,utilities_system/* isProd */.BB)());
    }, []);
    if (!showDebug) {
        return false;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* InternalLink */.h, {
        hasBackground: true,
        hasPadding: true,
        size: system/* Size.ExtraSmall */.$u.ExtraSmall,
        className: (debug_widget_module_default()).main,
        href: "/debug",
        icon: "FlaskConical",
        hierarchy: Button/* ButtonHierarchy.BezeledGray */.B.BezeledGray,
        children: experimentGroup
    });
};

;// CONCATENATED MODULE: ./components/styleguide/DebugWidget/index.ts



/***/ }),

/***/ 23273:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ InternalLink; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(14251);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(52875);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(44747);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Button_button_module_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(11069);
/* harmony import */ var _Button_button_module_scss__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_Button_button_module_scss__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _link_module_scss__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(14327);
/* harmony import */ var _link_module_scss__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_link_module_scss__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _components_styleguide_Button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96732);
/* harmony import */ var _types_system__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(16693);











var Icon = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(8075), __webpack_require__.e(9878), __webpack_require__.e(6244)]).then(__webpack_require__.bind(__webpack_require__, 56244));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(56244)
            ];
        }
    }
});
var InternalLink = function(_param) {
    var children = _param.children, _hierarchy = _param.hierarchy, hierarchy = _hierarchy === void 0 ? _components_styleguide_Button__WEBPACK_IMPORTED_MODULE_4__/* .ButtonHierarchy.Borderless */ .B.Borderless : _hierarchy, _size = _param.size, size = _size === void 0 ? _types_system__WEBPACK_IMPORTED_MODULE_5__/* .Size.Medium */ .$u.Medium : _size, _className = _param.className, className = _className === void 0 ? "" : _className, icon = _param.icon, _hasPadding = _param.hasPadding, hasPadding = _hasPadding === void 0 ? false : _hasPadding, _hasBackground = _param.hasBackground, hasBackground = _hasBackground === void 0 ? false : _hasBackground, _hasUnderline = _param.hasUnderline, hasUnderline = _hasUnderline === void 0 ? false : _hasUnderline, _hasTransition = _param.hasTransition, hasTransition = _hasTransition === void 0 ? false : _hasTransition, _hasIcon = _param.hasIcon, hasIcon = _hasIcon === void 0 ? false : _hasIcon, _isFullWidth = _param.isFullWidth, isFullWidth = _isFullWidth === void 0 ? false : _isFullWidth, _isSquare = _param.isSquare, isSquare = _isSquare === void 0 ? false : _isSquare, _theme = _param.theme, theme = _theme === void 0 ? _types_system__WEBPACK_IMPORTED_MODULE_5__/* .Theme.light */ .Q2.light : _theme, onClick = _param.onClick, restProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_param, [
        "children",
        "hierarchy",
        "size",
        "className",
        "icon",
        "hasPadding",
        "hasBackground",
        "hasUnderline",
        "hasTransition",
        "hasIcon",
        "isFullWidth",
        "isSquare",
        "theme",
        "onClick"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, restProps), {
        passHref: true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
            className: "".concat((_Button_button_module_scss__WEBPACK_IMPORTED_MODULE_9___default().main), " ").concat((_link_module_scss__WEBPACK_IMPORTED_MODULE_10___default().link), " ").concat(className, " ").concat(isFullWidth ? (_link_module_scss__WEBPACK_IMPORTED_MODULE_10___default()["is-full-width"]) : ""),
            "data-hierarchy": hierarchy,
            "data-is-square": isSquare,
            "data-has-underline": hasUnderline,
            "data-has-background": hasBackground,
            "data-has-transition": hasTransition,
            "data-has-padding": hasPadding,
            "data-has-icon": !!icon || hasIcon,
            "data-size": size,
            onClick: onClick,
            "data-theme": theme,
            children: [
                icon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Icon, {
                    name: icon,
                    size: size === _types_system__WEBPACK_IMPORTED_MODULE_5__/* .Size.Large */ .$u.Large ? _types_system__WEBPACK_IMPORTED_MODULE_5__/* .Size.Large */ .$u.Large : _types_system__WEBPACK_IMPORTED_MODULE_5__/* .Size.Medium */ .$u.Medium
                }),
                children
            ]
        })
    }));
};


/***/ }),

/***/ 63383:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "d": function() { return /* reexport */ ExternalLink; },
  "h": function() { return /* reexport */ InternalLink/* InternalLink */.h; }
});

// EXTERNAL MODULE: ./components/styleguide/Link/InternalLink.tsx
var InternalLink = __webpack_require__(23273);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(14251);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(52875);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(44747);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/styleguide/Button/button.module.scss
var button_module = __webpack_require__(11069);
var button_module_default = /*#__PURE__*/__webpack_require__.n(button_module);
// EXTERNAL MODULE: ./components/styleguide/Link/link.module.scss
var link_module = __webpack_require__(14327);
var link_module_default = /*#__PURE__*/__webpack_require__.n(link_module);
// EXTERNAL MODULE: ./components/styleguide/Button/index.ts
var Button = __webpack_require__(96732);
// EXTERNAL MODULE: ./types/system.ts
var system = __webpack_require__(16693);
;// CONCATENATED MODULE: ./components/styleguide/Link/ExternalLink.tsx










var Icon = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(8075), __webpack_require__.e(9878), __webpack_require__.e(6244)]).then(__webpack_require__.bind(__webpack_require__, 56244));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(56244)
            ];
        }
    }
});
var ExternalLink = function(_param) {
    var children = _param.children, _hierarchy = _param.hierarchy, hierarchy = _hierarchy === void 0 ? Button/* ButtonHierarchy.Borderless */.B.Borderless : _hierarchy, _size = _param.size, size = _size === void 0 ? system/* Size.Medium */.$u.Medium : _size, _className = _param.className, className = _className === void 0 ? "" : _className, icon = _param.icon, _hasPadding = _param.hasPadding, hasPadding = _hasPadding === void 0 ? false : _hasPadding, _hasBackground = _param.hasBackground, hasBackground = _hasBackground === void 0 ? false : _hasBackground, _theme = _param.theme, theme = _theme === void 0 ? system/* Theme.light */.Q2.light : _theme, _hasUnderline = _param.hasUnderline, hasUnderline = _hasUnderline === void 0 ? false : _hasUnderline, _hasTransition = _param.hasTransition, hasTransition = _hasTransition === void 0 ? false : _hasTransition, _isFullWidth = _param.isFullWidth, isFullWidth = _isFullWidth === void 0 ? false : _isFullWidth, _isSquare = _param.isSquare, isSquare = _isSquare === void 0 ? false : _isSquare, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "hierarchy",
        "size",
        "className",
        "icon",
        "hasPadding",
        "hasBackground",
        "theme",
        "hasUnderline",
        "hasTransition",
        "isFullWidth",
        "isSquare"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: "".concat((button_module_default()).main, " ").concat(className, " ").concat(isFullWidth ? (link_module_default())["is-full-width"] : ""),
        "data-hierarchy": hierarchy,
        "data-is-square": isSquare,
        "data-has-underline": hasUnderline,
        "data-has-background": hasBackground,
        "data-has-transition": hasTransition,
        "data-has-padding": hasPadding,
        "data-size": size,
        "data-theme": theme
    }, restProps), {
        children: [
            icon && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                name: icon,
                size: size === system/* Size.Large */.$u.Large ? system/* Size.Large */.$u.Large : system/* Size.Medium */.$u.Medium
            }),
            children
        ]
    }));
};

;// CONCATENATED MODULE: ./components/styleguide/Link/index.ts




/***/ }),

/***/ 16693:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$u": function() { return /* binding */ Size; },
/* harmony export */   "Q2": function() { return /* binding */ Theme; },
/* harmony export */   "ih": function() { return /* binding */ TestStatus; }
/* harmony export */ });
/* unused harmony export LoadingStatus */
var Theme;
(function(Theme) {
    Theme["light"] = "light";
    Theme["dark"] = "dark";
})(Theme || (Theme = {}));
var TestStatus;
(function(TestStatus) {
    TestStatus["Default"] = "default";
    TestStatus["Fail"] = "fail";
    TestStatus["Pass"] = "pass";
})(TestStatus || (TestStatus = {}));
var Size;
(function(Size) {
    Size["ExtraSmall"] = "xs";
    Size["Small"] = "sm";
    Size["Medium"] = "md";
    Size["Large"] = "lg";
    Size["ExtraLarge"] = "xl";
    Size["ExtraExtraLarge"] = "2xl";
})(Size || (Size = {}));
var LoadingStatus;
(function(LoadingStatus) {
    LoadingStatus["Loading"] = "loading";
    LoadingStatus["Complete"] = "complete";
})(LoadingStatus || (LoadingStatus = {}));


/***/ }),

/***/ 11069:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main":"button_main___eQSM","loader":"button_loader__U44JW","label":"button_label__K7r_v","rotate":"button_rotate__kRBLq","loader-container":"button_loader-container__Ik9J_","loader-dots":"button_loader-dots___PKOj","loaderDots":"button_loaderDots___4DhB","phAnimation":"button_phAnimation__XeQ3d"};

/***/ }),

/***/ 29183:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main":"debug-widget_main__OEGkm","phAnimation":"debug-widget_phAnimation__mgVBf"};

/***/ }),

/***/ 14327:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"link":"link_link__jP52i","is-full-width":"link_is-full-width___RhFm","phAnimation":"link_phAnimation__wE867"};

/***/ })

}]);